import { Component, HostBinding } from '@angular/core'
import { Sort } from '@angular/material/sort'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { AppUser, RoleManagerClient, AuthApiClient, AppRole, ApplicationArea, SetPasswordPayload } from 'src/app/shared/services/ppv.api'

//Run with \PPV.Web\ClientApp\ng serve
//Make sure PPV.API is running and are on the VPN

@Component({
   selector: 'role-manager',
   templateUrl: './role-manager.component.html',
   styleUrls: ['./role-manager.component.scss'],
   standalone: false,
})
export class RoleManagerComponent {
   @HostBinding('class.full-flex-height') fullFlexHeight = true

   selectedButton: string = 'users' // Track selected button
   setSelectedButton(button: string) {
      this.selectedButton = button
   }

   searchQuery: string = ''
   filteredUsers: AppUser[] = []
   selectedUserId: number | null = null
   selectedUser: AppUser[] = []
   allRoles: AppRole[] = []
   rolesForSelection: AppRoleForSelect[] = []

   selectedRoleToAdd: AppRole

   rolesForUser: { [key: string]: AppRole[] } = {}

   constructor(
      private authMgr: AuthManager,
      private router: Router,
      private roleManagerClient: RoleManagerClient,
      private authAppClient: AuthApiClient
   ) {
      this.authMgr.getCurrentUser().subscribe((user) => {})
   }

   ngOnInit() {
      this.searchQuery = ''
      this.filteredUsers = []
      this.selectedUserId = null
      this.getAllRoles()
   }

   getAllRoles(): void {
      this.roleManagerClient.getAllRoles().subscribe({
         next: (data) => {
            console.log(data)
            this.allRoles = data
         },
         error: (error) => {
            console.error('Error searching users:', error)
         },
      })
   }

   onSearchInput(): void {
      if (this.searchQuery.length < 3) {
         this.filteredUsers = []
         return
      }

      this.authAppClient.searchUsers(this.searchQuery).subscribe({
         next: (data) => {
            console.log(data)

            //only include items where displayName exists and is not empty
            // this.filteredUsers = data.filter((item) => item.displayName && item.displayName.trim().length > 0)
            this.filteredUsers = data.filter((item) => item.displayName && item.displayName.trim().length > 0).slice(0, 40)
         },
         error: (error) => {
            console.error('Error searching users:', error)
         },
      })
   }

   onRowClick(user: AppUser): void {
      console.log('Row clicked:', user)
      this.selectedUserId = this.selectedUserId === user.id ? null : user.id

      if (this.selectedUserId) {
         this.getRolesForUser(this.selectedUserId.toString())
      }
   }

   getRolesForUser(userId: string): void {
      this.roleManagerClient.getRolesForUser(userId).subscribe({
         next: (data) => {
            console.log(data)
            this.rolesForUser[userId] = data.sort((a, b) => a.application - b.application)

            this.rolesForSelection = this.allRoles
               .filter((ar) => !this.rolesForUser[userId]?.some((ur) => ur.application === ar.application && ur.roleName === ar.roleName))
               .map((ar) => ({
                  appRole: ar,
                  label: `${ar.application} ${ar.roleName}`,
               }))
               .sort((a, b) => a.appRole.application - b.appRole.application)
         },
         error: (error) => {
            console.error('Error getting roles for user:', error)
         },
      })
   }

   containsRole(user: AppUser, role: number): boolean {
      //get the role ids for this user
      var roleIdList = this.rolesForUser[user.id.toString()].map((role) => role.application)

      return roleIdList.includes(role)
   }

   removeRoleFromUser(user: AppUser, role: AppRole): void {
      console.log('remove role from user:', user)

      this.roleManagerClient.removeRoleFromUser(user.id, role.application).subscribe({
         next: (data) => {
            console.log(data)

            if (data === 1) {
               console.log('removing role')

               //update the dropdown
               this.selectedRoleToAdd = null
               this.getRolesForUser(user.id.toString())
            }
         },
         error: (error) => {
            console.error('Error removing role for user:', error)
         },
      })
   }

   addSelectedRoleToUser(user: AppUser) {
      this.roleManagerClient.addRoleToUser(user.id, this.selectedRoleToAdd.application).subscribe({
         next: (data) => {
            console.log(data)

            if (data === 1) {
               console.log('adding role')

               //update the dropdown
               this.selectedRoleToAdd = null
               this.getRolesForUser(user.id.toString())
            }
         },
         error: (error) => {
            console.error('Error adding role to user:', error)
         },
      })
   }

   onRoleToAddChange(val: AppRole) {
      //   const actualVal = typeof val === 'string' ? val : (val as { value?: string | null })?.value ?? null
      console.log('setting role to change: ')
      console.log(val)
      //   this.selectedRoleToAdd = val
      const found = this.rolesForSelection.find((role) => role.appRole === val)
      this.selectedRoleToAdd = found ? found.appRole : null
   }
}

interface AppRoleForSelect {
   appRole: AppRole
   label: string
}
